<template>
  <div>
      <video autoplay muted loop class="hover_video" src="@/assets/video/rctiplus.mp4"></video>
      <p class="description pd-top-40">
        RCTI+ mempersembahkan empat program spesial, beberapa diantaranya merupakan program reguler iconic dari RCTI+. Program spesial pertama yang ditayangkan adalah Musik Buat Elo Spesial HUT MNC Group ke 32, kemudian program spesial Parade Stand Up Comedy Celebrate a Brighter Future, Program Dai Muda Special HUT MNC Group ke 32, dan terakhir The Famous: The Magnificent Four. Saksikan semuanya hanya di RCTI+.
      </p>
      <!-- <p class="link description mg-top-20" @click="movePage()">Selengkapnya</p> -->
  </div>
</template>

<script>
export default {
  name: 'RCTI',
  data () {
    return {

    }
  },
  methods: {
    movePage() {
      this.$router.push('/rcti-plus')
    }
  }
}
</script>
